module.exports = __webpack_public_path__ + "static/img/sp_mypage.2ffe27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/images/sp_mypage.png
// module id = O2Ho
// module chunks = 0